import { render, staticRenderFns } from "./free.vue?vue&type=template&id=029599dc&scoped=true"
import script from "./free.vue?vue&type=script&lang=js"
export * from "./free.vue?vue&type=script&lang=js"
import style0 from "./free.vue?vue&type=style&index=0&id=029599dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029599dc",
  null
  
)

export default component.exports